import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faCubes, faDesktop } from '@fortawesome/free-solid-svg-icons';

import Routes from '../../utils/Routes';
import './ABMs.css';

function ABMs() {
    const navigate = useNavigate();

    const navigateTo = (route) => {
        navigate(route);
    };

    return (
        <div className="pageABMsView">
            <div className="multipleOptionsDiv">
                <div className="optionABMDiv">
                    <button onClick={() => navigateTo(Routes.usuarios)}>
                        <FontAwesomeIcon icon={faUsers} className='iconAbm' />
                        <label className="labelOptionABM">Usuarios</label>
                    </button>
                </div>
                <div className="optionABMDiv">
                    <button onClick={() => navigateTo(Routes.tenants)}>
                        <FontAwesomeIcon icon={faCubes} className='iconAbm' />
                        <label className="labelOptionABM">Tenants</label>
                    </button>
                </div>
                <div className="optionABMDiv">
                    <button onClick={() => navigateTo(Routes.plataformas)}>
                        <FontAwesomeIcon icon={faDesktop} className='iconAbm' />
                        <label className="labelOptionABM">Plataformas</label>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ABMs;
